export default "__VITE_ASSET__Dgux1moO__"